import script from "./Profiles.vue?vue&type=script&setup=true&lang=ts"
export * from "./Profiles.vue?vue&type=script&setup=true&lang=ts"

import "./Profiles.vue?vue&type=style&index=0&id=77f567c8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77f567c8"]])

export default __exports__